import * as React from "react";
function ClassLinkIcon({ title, titleId, className, ...props }, svgRef) {
	return (
		<svg
			ref={svgRef}
			className={className}
			id="classlink-icon"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="23 -113 128 128"
			width="128"
			height="128"
			fill="currentColor"
			stroke="transparent"
			aria-hidden="true"
			aria-labelledby={titleId}>
			{title && <title id={titleId}>{title}</title>}
			<g transform="matrix(0.95624311,0,0,0.9463675,0.66495019,89.148146)">
				<path d="m 62.5,-137.6 c 0,0 0,0 0,0 -5.2,5.9 0,8.8 0,8.8 0.2,0.1 0.4,0.2 0.6,0.2 -0.8,-3.2 -0.9,-6.2 -0.6,-9 z" />
				<path d="m 96.5,-129.9 c -4.1,2.8 -8.8,12 -8.8,12 h -2.5 c 1.6,-3.5 2.6,-6.4 3.2,-8.8 -0.6,0.2 -1,0.3 -1,0.3 -4.9,1.7 -9.9,2.5 -14.3,2.6 4.7,7 13.2,8.2 13.2,8.2 11.9,1.6 21,-4.9 25.8,-9.7 -10,-5.5 -15.6,-4.6 -15.6,-4.6 z" />
				<path d="m 135.1,-155.6 c 0,0 7.9,-19.5 -10.1,-32.9 0,0 -28.8,-19 -44.9,12.7 0,0 -11.5,-11.5 -25.7,-2.6 -12.2,7.6 -10.1,18 -9,23.1 0,0 -22.9,6.7 -21.8,31.2 0.8,18.1 18.4,23.6 25.2,25 1.5,0.3 3,0.5 4.5,0.5 h 75.3 c 1.5,0 2.9,-0.1 4.4,-0.4 6.9,-1.4 24.7,-6.9 24.4,-26.2 -0.4,-23.9 -22.3,-30.4 -22.3,-30.4 z m -49.4,43.8 C 70.5,-112 65,-123.4 65,-123.4 c -0.3,-0.6 -0.6,-1.2 -0.8,-1.8 -4.2,-1.6 -6.7,-4.5 -6.1,-8.9 0.6,-4.4 5.6,-8.8 5.6,-8.8 v 0 c 2.9,-9 9.4,-15.1 9.4,-15.1 0,0 5.5,-5.8 11.4,-8.8 l 10.4,1.6 c -23.5,9.6 -24.7,29.4 -24.7,29.4 -0.2,3 0.2,5.5 0.9,7.7 1.8,-0.1 3,-0.3 3,-0.3 5.8,-0.9 10.8,-2.5 15.1,-4.3 -0.1,-3.9 -1.9,-4.9 -1.9,-4.9 0,0 -2.1,-2.4 -10.9,-3.9 l 0.8,-1.2 c 0,0 4.3,1 9.2,0 5.3,-1 10.2,-4.7 15.7,-12.2 l 2.6,-0.1 c -5.3,7.1 -5.7,12.4 -4.8,15.9 5.3,-4 7.8,-7.4 7.8,-7.4 9.6,-13.4 -3.7,-11.3 -3.7,-11.3 l 4,-4.7 c 20.3,4.4 1.7,22.8 1.7,22.8 -2.2,2.2 -4.6,4.1 -6.9,5.8 0.3,0.4 3.9,4 10.6,7.2 1.8,-1.9 2.7,-3.3 2.7,-3.3 l 2.7,0.5 c -15.9,19.2 -33.1,17.7 -33.1,17.7 z m 7.2,-38.1 c -0.1,2.2 -1.9,4 -4.2,4.1 -2.5,0 -4.5,-2 -4.4,-4.5 0.1,-2.2 1.9,-4 4.2,-4.1 2.5,0 4.5,2 4.4,4.5 z" />
			</g>
		</svg>
	);
}
const ForwardRef = React.forwardRef(ClassLinkIcon);
export default ForwardRef;
